// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"431":"8cf96602","453":"24382d79"}[chunkId] + ".chunk.js";
};